import React from 'react';
import { FormattedMessage } from 'react-intl';
import axios from 'axios';
import { Button } from '@mui/material';

import GenericDialog from './GenericDialog';
import LoopbackProvider from '../loopback/LoopbackProvider';
import { BACKEND_URL } from '../environment';
import ApiClient from '../loopback/apiClient';
import { downloadFromContainer } from '../utilities/urlHelper';

const downloadAndReplaceFileName = (url: string, replaceFileName: string) => {
  // The invoice name is saved in a random guid and in order to download with a
  // different name, we have to download it first as a blob data.
  axios.get(url, {
    headers: {
      'Content-Type': 'application/pdf',
    },
    responseType: 'blob',
  }).then((res) => {
    const exportUrl = URL.createObjectURL(new File([res.data], url, { type: 'application/pdf' }));
    const tempLink = document.createElement('a');
    tempLink.href = exportUrl;
    tempLink.target = '_blank';
    tempLink.download = replaceFileName;
    tempLink.click();
    URL.revokeObjectURL(exportUrl);
  });
};

/**
 * download certificate
 *
 * @param id {number} - Certificate.id
 * @param fileName {string} - Certificate.file
 */
export const doDownloadCertificate = async (id: number, fileName: string) => {
  const exist = await ApiClient.checkCertificateExist(id);
  if (!exist) {
    await ApiClient.createCertificateFile(id);
  }

  downloadFromContainer('certificates', fileName);
};

type Props = {
  container: string;
  file?: string;
  isOpen: boolean;
  onClose: () => void;
  replaceFileName?: string;
  id?: number;
}

const DownloadDialog: React.FC<Props> = ({
  container,
  file,
  replaceFileName,
  isOpen,
  onClose,
  id,
}: Props) => {
  if (!file) {
    return null;
  }

  // if a replaceFileName is not given, the original file name will be used
  const fileName = replaceFileName ? `${replaceFileName}.pdf` : file;

  const url = `${BACKEND_URL}/Containers/${container}/download/${file}?access_token=${LoopbackProvider.loopbackToken.id}`;
  return (
    <GenericDialog isOpen={isOpen}>
      <div style={{ padding: '1em' }}>
        <h1><FormattedMessage id="containerdownload.message" /></h1>
        <Button
          variant="contained"
          className="ml0 ma3"
          color="primary"
          onClick={() => {
            if (container === 'certificates' && id !== undefined) {
              doDownloadCertificate(id, fileName);
              return;
            }

            downloadAndReplaceFileName(url, fileName);
          }}
        >
          <FormattedMessage id="containerdownload.download" />
        </Button>
        <Button
          variant="contained"
          className="ml0 ma3"
          color="primary"
          onClick={onClose}
        >
          <FormattedMessage id="containerdownload.cancel" />
        </Button>
      </div>
    </GenericDialog>
  );
};

export default DownloadDialog;
